const RESOURCE_NAME = '/greensee';
export default axios => ({
    get4Period(id, from, to, params) {
        if(id) {
            return axios.get(`${RESOURCE_NAME}/unit/${id}/events/${from}/${to}`, {params});
        }
        return axios.get(`${RESOURCE_NAME}/events/${from}/${to}`, {params});
    },
    get4Date(id, date, params) {
        if(id) {
            return axios.get(`${RESOURCE_NAME}/unit/${id}/events/${date}`, {params});
        }
        return axios.get(`${RESOURCE_NAME}/events/${date}`, {params});
    },
});